import { CUSTOMERINFO_URLS } from "../../services/apiConfig.js";
import { ACSIDENTITY_ERRORS } from "../../common/constants/ivrModule/acsConstants.js";
import apiClient from "../apiInstance.js";


export const getcustomernotes = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_NOTES, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const addcustomernotes = async ({customerguid, notesvalue, agentguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.ADD_CUSTOMER_NOTES, {
            customerguid,
            notesvalue,
            agentguid
        });
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.REFRESH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};